export default "__VITE_ASSET__CGVgFzuP__"